import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MfDocumentsComponent } from './mf-documents.component';
import { MfDocumentsRoutingModule } from './mf-documents-routing.module';
import { AppName, AppUrl } from '../microfrontend.tokens';
import { UpdateCompanyDataModule } from '../../shared/components/update-company-data/update.company-data.module';
import { NoLoginRegisterBannerModule } from '../../common/components/no-login-register-banner/no-login-register-banner.module';
import { CreateSequenceModule } from '@web-frontend/shared/components/create-sequence/create-sequence.module';
import { PermissionsModule } from '@web-frontend/shared/components/permissions';

const microfrontendKey = 'mf-documents';

@NgModule({
  declarations: [MfDocumentsComponent],
  imports: [
    CommonModule,
    MfDocumentsRoutingModule,
    UpdateCompanyDataModule,
    NoLoginRegisterBannerModule,
    CreateSequenceModule,
    PermissionsModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: AppName,
      useValue: microfrontendKey,
    },
    {
      provide: AppUrl,
      useFactory: () => {
        return localStorage.getItem(microfrontendKey);
      },
    },
  ],
  exports: [MfDocumentsComponent],
})
export class MfDocumentsModule {}
